import { render, staticRenderFns } from "./FeatureComingSoonDialog.vue?vue&type=template&id=d9f46ac8"
import script from "./FeatureComingSoonDialog.vue?vue&type=script&lang=js"
export * from "./FeatureComingSoonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9f46ac8')) {
      api.createRecord('d9f46ac8', component.options)
    } else {
      api.reload('d9f46ac8', component.options)
    }
    module.hot.accept("./FeatureComingSoonDialog.vue?vue&type=template&id=d9f46ac8", function () {
      api.rerender('d9f46ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/core/FeatureComingSoonDialog.vue"
export default component.exports